import { useQuery } from "@tanstack/react-query";

import { getProject, fetchTicketComments } from "../../../services/projects";

export function useTicketViewData(
  ticketId: string | null,
  options?: { pollingEnabled?: boolean },
) {
  const refetchInterval = options?.pollingEnabled ? 5000 : false;

  const ticket = useQuery({
    queryKey: ["ticket-view", ticketId],
    queryFn: () => getProject(ticketId!),
    enabled: !!ticketId,
    staleTime: refetchInterval ? 0 : 60_000,
    refetchInterval,
  });

  const comments = useQuery({
    queryKey: ["ticket-view-comments", ticketId],
    queryFn: () => fetchTicketComments({ ticketId: ticketId!, query: "" }),
    enabled: !!ticketId,
    staleTime: refetchInterval ? 0 : 60_000,
    refetchInterval,
  });

  const ticketData = ticket.data;
  const latestBoard = ticketData?.revisionBoards
    ?.filter((b) => !b.deletedAt)
    ?.at(-1);
  const contextFiles = latestBoard?.contextFiles ?? [];
  const hasContextAssets = contextFiles.length > 0;
  const latestReviewFiles = latestBoard?.reviewFiles ?? [];

  return {
    ticket: ticketData,
    comments: comments.data,
    isLoading: ticket.isLoading || comments.isLoading,
    hasContextAssets,
    contextFiles,
    latestReviewFiles,
  };
}
